import type { MergeCountsDto } from '../api/mergeResolution.types';

// The gate reads the screen's running counts: the server's counts at load,
// adjusted for the decisions made since (estimateCountsFromFacts). It is a
// courtesy to the user, not a check. Submit rebases first and refuses on the
// server's own counts, and the server validates again (DESIGN.md invariant 1).
export function submitGate(
  counts: MergeCountsDto | undefined,
  structuralBlocked: boolean,
  submitAvailable: boolean
): { enabled: boolean; reasons: string[] } {
  const reasons: string[] = [];

  // Check remaining conflicts. Unknown counts keep Submit off.
  if (counts === undefined) {
    reasons.push('Remaining conflicts: unknown');
  } else if (counts.Remaining > 0) {
    reasons.push(`Remaining conflicts: ${counts.Remaining}`);
  }

  // Check structural block.
  if (structuralBlocked) {
    reasons.push('A structural conflict blocks Submit');
  }

  // Check if submit is available.
  if (!submitAvailable) {
    reasons.push('Submit is not available in this release yet');
  }

  return {
    enabled: reasons.length === 0,
    reasons,
  };
}
